// src/interview/video/index.jsx
import React, { useCallback, useRef, useState, useEffect } from "react";
import Webcam from "react-webcam";
import microphoneSlash from "./../../assets/image/microphone_slash.svg";
import microphone from "./../../assets/image/microphone.svg";
import endCall from "./../../assets/image/end_call.svg";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import apiCall from "./../../utils/axiosCall";
import { useNavigate, useParams } from "react-router-dom";
import { endPoint } from "../../utils/endPoint";
import welcome_Message from "../../assets/audio/welcome.json";
import { usePopupModal } from "../../context/PopupModelContext";
import { useInterviewSecurity } from "../../utils/useInterviewSecurity";

const Video = ({
  pauseRecord,
  startRecord,
  pauseRecording,
  resumeRecording,
  recordingPermission,
  stopDisable,
  stop,
  setChat,
  chat,
  setMicrophone,
  setWriteAi,
  setAiAudioStream,
  callcut,
  handle,
  isFullScreen,
  setIsFullScreen,
  setPopupendCall,
  setCurrentInterviewStatus,
  currentInterviewStatus,
}) => {
  let { uuid } = useParams();
  const audioRef = useRef(new Audio());
  const webcamRef = useRef(null);
  const [message, setMessage] = React.useState("");
  const [sessionID, SetSessionID] = useState(
    "763a9ec4-bc43-4770-8436-ff09b5e94ba5"
  );
  const [conversationData, SetConversationData] = useState();
  let audio = new Audio();
  const [aiAudioPlay, setAiAudioPlay] = useState(false);
  const [currentChat, setCurrentChat] = useState([]);
  const [isCurrentConversationFetched, setIsCurrentConversationFetched] =
    useState(false);
  let count = 0;
  let interviewStatus = localStorage.getItem("interview_status");
  const current_session_id = localStorage.getItem("session_id");
  var interview_timing_id = localStorage.getItem("interview_timing_id", -1);
  const navigate = useNavigate();

  const [isInactive, setIsInactive] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [audioSource, setAudioSource] = useState(false);
  const [endcallPopup, setEndcallPopup] = useState(false);

  const { isOpen, setIsOpen } = usePopupModal();

  const [isMicDisabled, setIsMicDisabled] = useState(false);
  const [validationMessage, setValidationMessage] = useState("");
  
  // New state for manual navigation
  const [accumulatedTranscript, setAccumulatedTranscript] = useState("");
  const [isLastQuestion, setIsLastQuestion] = useState(false);
  const [isProcessingNextQuestion, setIsProcessingNextQuestion] = useState(false);
  const [isFetchingQuestion, setIsFetchingQuestion] = useState(false);

  // Timer state
  const [interviewDuration, setInterviewDuration] = useState(0);
  const [timeRemaining, setTimeRemaining] = useState(0);
  const timerRef = useRef(null);
  const [isTimerLoaded, setIsTimerLoaded] = useState(false);

  const [fullScreen, setFullScreen] = useState(!!document.fullscreenElement);
  const [shouldReEnableMic, setShouldReEnableMic] = useState(true);

    // First useEffect - Runs once on component mount
    useEffect(() => {
        // Set microphone to false when component first loads
        console.log("Component mounted - disabling microphone");
        setMicrophone(false);
        SpeechRecognition.stopListening();
        setIsMicDisabled(true);
    }, []); // Empty dependency array

    // Second useEffect - Keeps mic disabled until interview starts
    useEffect(() => {
        if (!startRecord) {
            // Interview hasn't started yet - keep mic disabled
            setMicrophone(false);
            SpeechRecognition.stopListening();
            setIsMicDisabled(true);
        }
    }, [startRecord]);

  // ADD THESE 2 LINES RIGHT AFTER STATE DECLARATIONS
  const handleEndCallClickRef = useRef(null);
  useInterviewSecurity(fullScreen, () => {
    if (handleEndCallClickRef.current) {
      handleEndCallClickRef.current();
    }
  }, startRecord);

  var inactivityTimeOut = 9000000;
  var popupTimeOut = 6000000;
  var showPopupTimeOut = 6000000;
  var terminatedPopupTimeout = 3000000;

  let inactivityTimer;
  let popupTimer;
  let showPopupTimer;
  const terminatedPopupTimer = useRef(null);

  const resetTimer = useCallback(() => {
    setIsInactive(false);
    setShowPopup(false);
    clearTimeout(inactivityTimer);
    clearTimeout(popupTimer);
    clearTimeout(showPopupTimer);
    startTimers();
  }, []);

  const startTimers = () => {
    inactivityTimer = setTimeout(() => {
      setIsInactive(true);
    }, inactivityTimeOut);

    popupTimer = setTimeout(() => {
      setShowPopup(true);
      startPopupAlertTimer();
    }, popupTimeOut);
  };

  const startPopupAlertTimer = () => {
    showPopupTimer = setTimeout(() => {
      handleEndCallClick();
    }, showPopupTimeOut);
  };
    
  // Fetch timer info from API
  useEffect(() => {
    const fetchInterviewInfo = async () => {
      if (!current_session_id) return;
      
      try {
        const response = await apiCall({
          url: endPoint.FETCH_INTERVIEW_INFO,
          method: "post",
          data: JSON.stringify({ session_id: current_session_id }),
        });
        console.log("Timer API response:", response);
        
        // Convert MM.SS format to seconds
        const timerValue = response?.result?.timer || 30;
        const minutes = Math.floor(timerValue);
        const seconds = Math.round((timerValue - minutes) * 100);
        const totalSeconds = (minutes * 60) + seconds;
        
        console.log("Total seconds for timer:", totalSeconds);
        setInterviewDuration(totalSeconds);
        setTimeRemaining(totalSeconds);
        setIsTimerLoaded(true);
      } catch (error) {
        console.error("Error fetching timer:", error);
        // Default to 30 minutes if API fails
        const defaultTime = 1800; // 30 minutes
        setInterviewDuration(defaultTime);
        setTimeRemaining(defaultTime);
        setIsTimerLoaded(true);
      }
    };
    
    fetchInterviewInfo();
  }, [current_session_id]);

  useEffect(() => {
    startTimers();
    return () => {
      clearTimeout(showPopupTimer);
      clearTimeout(inactivityTimer);
      clearTimeout(popupTimer);
    };
  }, [resetTimer]);

  useEffect(() => {
    if (isOpen) {
      terminatedPopupTimer.current = setTimeout(() => {
        handleEndCallClick();
      }, terminatedPopupTimeout);
    } else {
      clearTimeout(terminatedPopupTimer.current);
      terminatedPopupTimer.current = null;
    }
    return () => clearTimeout(terminatedPopupTimer.current);
  }, [isOpen]);

  useEffect(() => {
    console.log("RIGHT NOW CHAT", chat);
  }, [chat]);

  const handlePopupResponse = (response) => {
    if (response === "yes") {
      clearTimeout(showPopupTimer);
      resetTimer();
    } else {
      handleEndCallClick();
    }
  };

  function base64ToArrayBuffer(base64) {
    const binary_string = window.atob(base64);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    hours = String(hours).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${ampm}`;
  };

  const getConversationData = async (userAnswer, isSkipped = false) => {
    console.log("getConversationData called:", { userAnswer, isSkipped });

    clearTimeout(popupTimer);
    startTimers();

    const now = new Date();
    const formattedTime = formatDate(now);

    let conversationData = {
      session_id: current_session_id,
      user_answer: isSkipped ? "[SKIPPED]" : userAnswer,
      answer_timestamp: formattedTime ? formattedTime : "",
    };

    const JsonData = {
      url: endPoint.CONVERSATION,
      method: "post",
      data: JSON.stringify(conversationData),
    };
    var apiResponse = await apiCall(JsonData);
    console.log("API 1001:",apiResponse);
    if (apiResponse?.return_code === "") {
    }
    SetConversationData(apiResponse?.result);
    localStorage.setItem(
      "interview_status",
      apiResponse?.result?.interview_status
    );
    if (interview_timing_id !== apiResponse?.result?.interview_timing_id) {
      localStorage.setItem(
        "interview_timing_id",
        apiResponse?.result?.interview_timing_id
      );
    }
    
    // Check if this is the last question
    if (apiResponse?.result?.interview_status === "completed" || 
        apiResponse?.result?.is_last_question === true) {
      setIsLastQuestion(true);
    } else {
      setIsLastQuestion(false);
    }
    
    clearTimeout(popupTimer);
    resetTimer();
    return apiResponse;
  };
  
  var countInterview = 1;

  useEffect(() => {
    const fetchData = async () => {
      try {
        let recordTimeData = {
          session_id: current_session_id,
          interview_timing_id: interview_timing_id,
          end_time: new Date().toISOString(),
        };

        const JsonData = {
          url: endPoint.RECORD_INTERVIEW_TIME,
          method: "post",
          data: JSON.stringify(recordTimeData),
        };
        var InterviewTimingValueResponse = await apiCall(JsonData);
        
        if (
          InterviewTimingValueResponse?.return_code ===
          "fetched_interview_timing_success"
        ) {
          if (
            InterviewTimingValueResponse?.result?.interview_timing_id !==
            interview_timing_id
          ) {
            localStorage.setItem("interview_timing_id", interview_timing_id);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    const intervalId = setInterval(() => {
      fetchData();
    }, 1000 * 5);
    resetTimer();
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    var getSessionData = async () => {
      try {
        const JsonData = {
          url: `${endPoint.GET_SESSION_INFO}${uuid}`,
          method: "get",
        };
        const sessionValue = await apiCall(JsonData);
        
        localStorage.setItem("session_id", sessionValue.result.session_id);
        localStorage.setItem("uuid", sessionValue.result.interview_id);
        localStorage.setItem("interview_id", sessionValue.result.interview_id);
        localStorage.setItem(
          "interview_status",
          sessionValue.result.interview_status
        );
      } catch (error) {
        localStorage.setItem("interview_status", "completed");
        setPopupendCall(true);
        setIsFullScreen(false);
        handle.exit();
      }
    };

    if (!current_session_id) {
      getSessionData();
    }

    const checkInterviewStatus = async () => {
      if (interviewStatus === "not_started") {
        setIsCurrentConversationFetched(true);
      }
      if (interviewStatus === "in_progess") {
        let data = {
          session_id: current_session_id,
          interview_type: "AI",
        };

        const JsonData = {
          url: endPoint.FETCH_CURRENT_CONVERSATION,
          method: "post",
          data: JSON.stringify(data),
        };
        var apiResponse = await apiCall(JsonData);

        if (
          apiResponse.return_code === "fetched_current_conversation_success"
        ) {
          const output_data = [];
          let chatData = apiResponse?.result?.conversation_data;
          if (chatData) {
            chatData.forEach((item) => {
              const questionObj = {
                type: "ai",
                message: item.question,
                createdAt: item.formatted_question_timestamp,
                questionID: item.question_id,
              };
              output_data.push(questionObj);
              if (item.answer) {
                const answerObj = {
                  type: "user",
                  message: item.answer,
                  createdAt: item.formatted_answer_timestamp,
                  questionID: item.question_id,
                };
                output_data.push(answerObj);
              }
            });
            let last_object = output_data.slice(-1)[0];

            if (last_object?.type === "ai") {
                setMicrophone(false);
                SpeechRecognition.stopListening();
                setIsMicDisabled(true);
              const getTextAudioData = async () => {
                let data = {
                  question_id: last_object.questionID,
                  text: last_object.message,
                  interview_type: localStorage.getItem(
                    "resourceful_interview_type"
                  ),
                };

                const JsonData = {
                  url: endPoint.FETCH_AUDIO,
                  method: "post",
                  data: JSON.stringify(data),
                };
                var apiResponse = await apiCall(JsonData);

                SetConversationData(apiResponse?.result);

                return apiResponse;
              };

              const fetchData = async () => {
                const response = await getTextAudioData(last_object.message);
                return response;
              };

              const response = await fetchData();
              setTimeout(() => {
                getStreamAudio(response?.result?.audio);
              }, 3500);
            }
            setChat(output_data);
            setCurrentChat(output_data);
            count += 1;
            setIsCurrentConversationFetched(true);
          }
        }
      }
    };
    if (countInterview === 1) {
      checkInterviewStatus();
      countInterview += 2;
    }
  }, []);

  useEffect(() => {
    const updateTimeStamp = async (currentChat) => {
      let question_timestamp;
      let answer_timestamp = "";
      let questionID;
      for (let i = chat.length - 1; i >= 0; i--) {
        const message = chat[i];
        if (message.type === "user") {
          answer_timestamp = message.createdDateTimeAt;
        }

        if (message.type === "ai") {
          question_timestamp = message.createdDateTimeAt;
          questionID = message.questionID;
        }

        if (questionID && question_timestamp) {
          break;
        }
      }
      if (questionID && question_timestamp) {
        let data = {
          question_id: questionID,
          question_timestamp: question_timestamp,
          answer_timestamp: answer_timestamp,
          interview_type: "AI",
        };

        const JsonData = {
          url: endPoint.UPDATE_TIMESTAMP,
          method: "post",
          data: JSON.stringify(data),
        };
        var apiResponse = await apiCall(JsonData);
        return;
      }
    };
    updateTimeStamp(currentChat);
  }, [currentChat]);

  const getCurrentTime = () => {
    const date = new Date();
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    let timeFormat = "24";
    let meridiem = "";
    if (hours > 12) {
      hours -= 12;
      meridiem = "PM";
      timeFormat = "12";
    } else if (hours === 0) {
      hours = 12;
      meridiem = "AM";
      timeFormat = "12";
    } else {
      meridiem = "AM";
    }

    hours = hours < 10 ? `0${hours}` : hours;
    const formattedTime = `${hours}:${minutes < 10 ? `0${minutes}` : minutes}:${
      seconds < 10 ? `0${seconds}` : seconds
    }`;
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day} ${formattedTime} ${
      timeFormat === "12" ? meridiem : "AM"
    }`;
  };
  
  const getTimeOnly = (dateTimeStr) => {
    return dateTimeStr.split(" ")[1] + " " + dateTimeStr.split(" ")[2];
  };

  const videoConstraints = {
    width: 2000,
    height: 920,
    facingMode: "user",
  };

  const commands = [
    {
      command: "reset",
      callback: () => resetTranscript(),
    },
    {
      command: "shut up",
      callback: () => setMessage("I wasn't talking."),
    },
    {
      command: "Hello",
      callback: () => setMessage("Hi there!"),
    },
  ];

  const {
    transcript,
    interimTranscript,
    finalTranscript,
    resetTranscript,
    listening,
  } = useSpeechRecognition({ commands });

  // Handle accumulated transcript
  useEffect(() => {
    if (finalTranscript && !isFetchingQuestion && !isProcessingNextQuestion) {
      setAccumulatedTranscript((prev) => {
        const newTranscript = prev + (prev ? " " : "") + finalTranscript.trim();
        return newTranscript;
      });
      resetTranscript();
    }
  }, [finalTranscript, isFetchingQuestion, isProcessingNextQuestion, resetTranscript]);

  // Display current transcript
  const displayTranscript = accumulatedTranscript + (accumulatedTranscript && interimTranscript ? " " : "") + interimTranscript;

  useEffect(() => {
    if (callcut === true) {
      handleEndCallClick();
    }
  }, [callcut]);

  // Handle Next button click
  const handleNextQuestion = useCallback(async () => {
    if (isFetchingQuestion) return;

    const userAnswer = accumulatedTranscript.trim() || transcript.trim();
    
    if (!userAnswer) {
      setValidationMessage("Please provide an answer before moving to the next question.");
      setIsOpen(true);
      return;
    }

    setIsProcessingNextQuestion(true);
    SpeechRecognition.stopListening();
    setMicrophone(false);
    resetTranscript();
    setAccumulatedTranscript("");

    await new Promise(resolve => setTimeout(resolve, 100));

    const datetime = getCurrentTime();
    const time = getTimeOnly(datetime);

    const newChatObject = {
      type: "user",
      message: userAnswer,
      createdAt: time,
      createdDateTimeAt: datetime,
    };
    
    setChat((prevChats) => [...prevChats, newChatObject]);
    setCurrentChat((prevChats) => [...prevChats, newChatObject]);

    setWriteAi(true);
    setIsFetchingQuestion(true);

    try {
      const response = await getConversationData(userAnswer);
      console.log("response:",response);
      const AiQuestion = response?.result?.ai_response?.question;
      console.log("AiQuestion:",AiQuestion);
      const questionID = response?.result?.question_id;
      const newDatetime = getCurrentTime();
      const newTime = getTimeOnly(newDatetime);

      const aiChatObject = {
        type: "ai",
        message: AiQuestion,
        createdAt: newTime,
        questionID: questionID,
        createdDateTimeAt: newDatetime,
      };

      setChat((prevChats) => [...prevChats, aiChatObject]);
      setCurrentChat((prevChats) => [...prevChats, aiChatObject]);
      setWriteAi(false);

      let audioContent =
        response.return_code === "prediction_success"
          ? response?.result?.ai_response_audio
          : null;
      
        // Audio will handle enabling microphone when it ends
        await getStreamAudio(audioContent);
        setIsFetchingQuestion(false);

        resetTranscript();
        setAccumulatedTranscript("");
        setIsProcessingNextQuestion(false);

      if (response?.result?.interview_status === "completed") {
        await handleEndCallClick();
        if (webcamRef.current) {
          webcamRef.current = null;
        }
        SpeechRecognition.stopListening();
        setAiAudioPlay(false);
        stop();
      }
    } catch (error) {
      console.error("Error in handleNextQuestion:", error);
      alert(`Failed to save your answer: ${error.message}\n\nPlease check your internet connection and try again.`);
      setIsFetchingQuestion(false);
      setIsProcessingNextQuestion(false);
      setWriteAi(false);
      setMicrophone(true);
      listenContinuously();
    }
  }, [accumulatedTranscript, transcript, isFetchingQuestion, chat]);

  // Handle Finish button click
  const handleFinishInterview = useCallback(async () => {
    if (isFetchingQuestion) return;

    const userAnswer = accumulatedTranscript.trim() || transcript.trim();
    
    if (!userAnswer) {
      await handleSkipQuestion();
      return;
    }

    audioOff();
    const datetime = getCurrentTime();
    const time = getTimeOnly(datetime);

    const newChatObject = {
      type: "user",
      message: userAnswer,
      createdAt: time,
      createdDateTimeAt: datetime,
    };
    
    setChat((prevChats) => [...prevChats, newChatObject]);
    setCurrentChat((prevChats) => [...prevChats, newChatObject]);

    resetTranscript();
    setAccumulatedTranscript("");
    setWriteAi(true);
    setIsFetchingQuestion(true);

    try {
      const response = await getConversationData(userAnswer);
      setWriteAi(false);
      setIsFetchingQuestion(false);

      await handleEndCallClick();
      if (webcamRef.current) {
        webcamRef.current = null;
      }
      SpeechRecognition.stopListening();
      setAiAudioPlay(false);
      stop();
    } catch (error) {
      console.error("Error in handleFinishInterview:", error);
      alert(`Failed to save your final answer: ${error.message}\n\nPlease check your internet connection and try again.`);
      setIsFetchingQuestion(false);
      setWriteAi(false);
    }
  }, [accumulatedTranscript, transcript, isFetchingQuestion, chat]);

  // Handle Skip button click
  const handleSkipQuestion = useCallback(async () => {
    console.log("Skip button clicked");

    if (isFetchingQuestion) {
      console.log("Skip blocked - already fetching question");
      return;
    }

    // STOP ANY CURRENTLY PLAYING AUDIO FIRST
    stopAudioValue();

    SpeechRecognition.stopListening();
    setMicrophone(false);
    resetTranscript();
    setAccumulatedTranscript("");

    await new Promise(resolve => setTimeout(resolve, 100));
    
    setIsMicDisabled(true); // Disable mic while processing

    const datetime = getCurrentTime();
    const time = getTimeOnly(datetime);

    const newChatObject = {
      type: "user",
      message: "[SKIPPED]",
      createdAt: time,
      createdDateTimeAt: datetime,
    };
    
    setChat((prevChats) => [...prevChats, newChatObject]);
    setCurrentChat((prevChats) => [...prevChats, newChatObject]);

    // resetTranscript();
    // setAccumulatedTranscript("");
    setWriteAi(true);
    setIsFetchingQuestion(true);

    try {
      const response = await getConversationData("", true);
      console.log("response:",response);
      const AiQuestion = response?.result?.ai_response?.question;
      console.log("AiQuestion:",AiQuestion);
      const questionID = response?.result?.question_id;
      const newDatetime = getCurrentTime();
      const newTime = getTimeOnly(newDatetime);

      const aiChatObject = {
        type: "ai",
        message: AiQuestion,
        createdAt: newTime,
        questionID: questionID,
        createdDateTimeAt: newDatetime,
      };

      setChat((prevChats) => [...prevChats, aiChatObject]);
      setCurrentChat((prevChats) => [...prevChats, aiChatObject]);
      setWriteAi(false);

      let audioContent =
        response.return_code === "prediction_success"
          ? response?.result?.ai_response_audio
          : null;
    
      // Re-enable mic re-enabling before playing new audio
      setShouldReEnableMic(true);
      
      await getStreamAudio(audioContent);
      setIsFetchingQuestion(false);

        //if (listening) setMicrophone(true);
        resetTranscript();
        setAccumulatedTranscript("");
      
      if (response?.result?.interview_status === "completed") {
        await handleEndCallClick();
        if (webcamRef.current) {
          webcamRef.current = null;
        }
        SpeechRecognition.stopListening();
        setAiAudioPlay(false);
        stop();
      }
    } catch (error) {
        console.error("Error in handleSkipQuestion:", error);
        alert(`Failed to skip question: ${error.message}\n\nPlease check your internet connection and try again.`);
        setIsFetchingQuestion(false);
        setWriteAi(false);
        setIsMicDisabled(false);
        setMicrophone(true);
        listenContinuously();
    }
  }, [isFetchingQuestion, chat]);

  // Auto-submit when timer expires
  const autoSubmitAndEndInterview = useCallback(async () => {
    console.log("Timer expired - auto-submitting and ending interview");

    // Stop microphone immediately
    SpeechRecognition.stopListening();
    setIsMicDisabled(true);
    setMicrophone(false);

    const transcriptToSubmit = accumulatedTranscript.trim();

    if (transcriptToSubmit) {
      console.log("Submitting accumulated transcript:", transcriptToSubmit);

      try {
        await getConversationData(transcriptToSubmit);
        console.log("Answer submitted successfully before timer end");
        setAccumulatedTranscript("");
      } catch (error) {
        console.error("Error submitting answer on timer end:", error);
      }
    } else {
      console.log("No transcript to submit on timer end");
    }

    // End interview after submission attempt
    await new Promise(resolve => setTimeout(resolve, 500));
    await handleEndCallClick();
  }, [accumulatedTranscript]);

  useEffect(() => {
    const fetchData = async () => {
      if (isCurrentConversationFetched) {
        count += 1;
        try {
          setWriteAi(true);
          // DISABLE MICROPHONE when AI starts responding
           setMicrophone(false);
           SpeechRecognition.stopListening();

          const response = await getConversationData("Hello, how are you");
          const datetime = getCurrentTime();
          const time = getTimeOnly(datetime);
          SetSessionID(response?.result?.session_id);
          const messageAi = response?.result?.ai_response?.question;
          const questionID = response?.result?.question_id;

          const newData = Array.isArray(chat)
            ? [
                ...chat,
                {
                  type: "ai",
                  message: messageAi,
                  createdAt: time,
                  createdDateTimeAt: datetime,
                  questionID: questionID,
                },
              ]
            : [];

          setChat(newData);
          setCurrentChat(newData);
          
          let audioContent =
            response.return_code === "prediction_success"
              ? response?.result?.ai_response_audio
              : null;
          
          getStreamAudio(audioContent);
          setWriteAi(false);
        } catch (error) {
          setWriteAi(false);
          console.error("Error fetching conversation data:", error);
        }
      }
      setWriteAi(false);
    };
    
    if (startRecord && chat.length === 0) {
      if (window.performance) {
        if (performance.navigation.type === 1) {
        } else {
            // DISABLE MICROPHONE during welcome message
            SpeechRecognition.stopListening();
            setMicrophone(false);
          const byteCharacters = atob(welcome_Message.audioContent);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "audio/mp3" });

          const audioUrl = URL.createObjectURL(blob);
          const audio = new Audio(audioUrl);
          audio.play();
        }
      }

      setTimeout(() => {
        fetchData();
      }, 4000);
    }
  }, [startRecord, isCurrentConversationFetched]);
  
  useEffect(() => {
    const checkFullScreen = () => {
      setFullScreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", checkFullScreen);
    return () => {
      document.removeEventListener("fullscreenchange", checkFullScreen);
    };
  }, []);

  useEffect(() => {
    if (!fullScreen) {
        console.log("🎤 Exited fullscreen - disabling microphone");
        audioOff();
    } else if (fullScreen && startRecord) {
        console.log("🎤 Entered fullscreen with interview started");
        // Don't auto-enable mic here - let the audio end handler control it
    }
    }, [fullScreen, startRecord]);

  useEffect(() => {
      const handleKeyDown = (e) => {
        if (fullScreen) {
          if (e.key === "Escape") return;
            e.preventDefault();
            e.stopPropagation();
        handleEndCallClick();
        }
      };
    }, [fullScreen]);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.hidden) {
                handleEndCallClick();
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

  // Timer countdown useEffect
  useEffect(() => {
    // Only start timer if:
    // 1. Interview has started (startRecord is true)
    // 2. Timer data is loaded from API (isTimerLoaded is true)
    // 3. There is time remaining (timeRemaining > 0)
    if (startRecord && isTimerLoaded && timeRemaining > 0) {
      console.log("Starting timer:", timeRemaining, "seconds");
      
      // Clear any existing timer
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }

      // Start countdown
      timerRef.current = setInterval(() => {
        setTimeRemaining((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(timerRef.current);
            console.log("Timer ended! Auto-submitting and ending interview");
            autoSubmitAndEndInterview();
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
    } else {
      // Clear interval if conditions not met
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    }

    // Cleanup on component unmount
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [startRecord, isTimerLoaded, timeRemaining, autoSubmitAndEndInterview]);

  // Helper function to format seconds into MM:SS
  const formatTime = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    
    const paddedMinutes = String(minutes).padStart(2, '0');
    const paddedSeconds = String(seconds).padStart(2, '0');
    
    return `${paddedMinutes}:${paddedSeconds}`;
  };

  if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
    alert("Your browser does not support speech recognition software! Try Chrome desktop, maybe?");
    return null;
  }

  let isAudioplaying = false;

  const listenContinuously = () => {
    if (!isAudioplaying && !isFetchingQuestion && startRecord) {
      if (recordingPermission && !pauseRecord) {
        SpeechRecognition.stopListening();
        setTimeout(() => {
          SpeechRecognition.startListening({
            continuous: true,
            language: "en",
          });
          setMicrophone(true);
        }, 100);
      } else {
        alert("Your interview will begin after permission to screen record.");
      }
    }
  };

  function isFullScreenMode() {
    return !!(
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    );
  }

  async function getStreamAudio(audioContent) {
    if (audioContent && currentInterviewStatus !== "completed") {
      setIsMicDisabled(true);
      SpeechRecognition.stopListening();
      isAudioplaying = true;
      setMicrophone(false);
      let audioContentData = audioContent;
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const destination = audioContext.createMediaStreamDestination();
      const audioData = base64ToArrayBuffer(audioContentData);

      window.currentAudioContext = audioContext;

      audioContext.decodeAudioData(audioData, (buffer) => {
        const source = audioContext.createBufferSource();
        source.buffer = buffer;
        source.connect(audioContext.destination);
        const gainNode = audioContext.createGain();
        gainNode.gain.value = 1;

        source.connect(gainNode);
        gainNode.connect(audioContext.destination);
        gainNode.connect(destination);
        setAiAudioStream(destination.stream);
        setAudioSource(source);
        window.currentAudioSource = source;

        const statusCheckInterval = setInterval(() => {
          if (currentInterviewStatus === "completed") {
            clearInterval(statusCheckInterval);
            source.stop();
            audioContext.close();
            isAudioplaying = false;
          }
        }, 100);

        source.start(0);
        // setMicrophone(true); // Enable microphone UI state
        source.onended = () => {
            clearInterval(statusCheckInterval);
            isAudioplaying = false;
            setIsMicDisabled(false);
            
            // Check fullscreen (startRecord might be false when resuming interview)
            if (isFullScreenMode()) {
                setTimeout(() => {
                    resetTranscript();
                    setAccumulatedTranscript("");
                    
                    // Check if interview is active (either just started OR resumed)
                    const interviewActive = startRecord || interviewStatus === "in_progess";
                    
                    console.log("Mic enable check:", {
                        recordingPermission,
                        pauseRecord,
                        isFetchingQuestion,
                        isAudioplaying,
                        startRecord,
                        interviewStatus,
                        interviewActive
                    });
                    
                    if (recordingPermission && !pauseRecord && interviewActive) {
                        SpeechRecognition.stopListening();
                        setTimeout(() => {
                            SpeechRecognition.startListening({
                                continuous: true,
                                language: "en",
                            });
                            setMicrophone(true);
                        }, 100);
                    } else {
                        console.error("Cannot start mic - conditions not met");
                    }
                }, 300);
            }
        };
      });
    } else {
        isAudioplaying = false;
        // If no audio, enable microphone immediately
        setIsMicDisabled(false);
        if (isFullScreenMode()) {
        setTimeout(() => {
            setMicrophone(true);
            listenContinuously();
        }, 300);
        }
    }
  }

    // Modify stopAudioValue function
    function stopAudioValue() {
        // Prevent onended from re-enabling mic
        setShouldReEnableMic(false);
        
        if (window.currentAudioSource) {
        try {
            window.currentAudioSource.stop();
        } catch (e) {
            console.log("Error stopping audio source:", e);
        }
        }

        if (window.currentAudioContext) {
        try {
            window.currentAudioContext.close();
        } catch (e) {
            console.log("Error closing audio context:", e);
        }
        }

        window.currentAudioSource = null;
        window.currentAudioContext = null;

        if (audioSource) {
        try {
            audioSource.stop();
        } catch (e) {
            console.log("Error stopping audioSource state:", e);
        }
        }
        
        isAudioplaying = false;
    }
  
  function audioOff() {
    SpeechRecognition.stopListening();
    setMicrophone(false);
  }

  const stopAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setAiAudioPlay(false);
    }
  };

  const endInterviewCall = async () => {
    let data = {
      session_id: current_session_id,
      interview_timing_id: interview_timing_id,
    };

    const JsonData = {
      url: endPoint.CONVERSATION_END,
      method: "post",
      data: JSON.stringify(data),
    };
    var apiResponse = await apiCall(JsonData);
    if (apiResponse?.return_code === "call_ended_success") {
      localStorage.setItem("interview_status", "completed");
    }
  };

  const handlePopupCall = async (e) => {
    if (endcallPopup == false) {
      setEndcallPopup(true);
    }
  };
  
  const endcallPopupResponse = (response) => {
    if (response === "yes") {
      setIsOpen(false);
      handleEndCallClick();
    } else {
      setEndcallPopup(false);
    }
  };

  const handleEndCallClick = async () => {
    // Clear timer interval
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    stopAudioValue();
    setCurrentInterviewStatus("completed");
    await endInterviewCall();
    if (webcamRef.current) {
      webcamRef.current = null;
    }
    setIsFullScreen(false);
    setPopupendCall(true);
    handle.exit();
    SpeechRecognition.stopListening();
    setAiAudioPlay(false);
    stopAudio();
    stop();
  };

    // ADD THIS LINE RIGHT AFTER handleEndCallClick
    handleEndCallClickRef.current = handleEndCallClick;

  return (
    <>
      {showPopup && (
        <div className='popup'>
          <div
            className={`fixed inset-0 z-10 transition-opacity ${
              showPopup
                ? "ease-out duration-300 opacity-100"
                : "ease-in duration-200 opacity-0"
            }`}
            aria-labelledby='modal-title'
            role='dialog'
            aria-modal='true'
          >
            <div className='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity'></div>

            <div className='fixed inset-0 z-10 w-screen overflow-y-auto'>
              <div className='flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0'>
                <div
                  className={`relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg ${
                    showPopup
                      ? "ease-out duration-300 opacity-100 translate-y-0 sm:scale-100"
                      : "ease-in duration-200 opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  }`}
                >
                  <div className='bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4'>
                    <div className='sm:flex items-center'>
                      <div className='mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10'>
                        <svg
                          className='text-red-600 w-6 h-6'
                          aria-hidden='true'
                          xmlns='http://www.w3.org/2000/svg'
                          fill='none'
                          viewBox='0 0 20 20'
                        >
                          <path
                            stroke='currentColor'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth='2'
                            d='M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z'
                          />
                        </svg>
                      </div>
                      <div className='mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left'>
                        <h3
                          className='text-base font-semibold leading-6 text-gray-900'
                          id='modal-title'
                        >
                          Are you still there?
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div className='bg-white px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6'>
                    <button
                      type='button'
                      onClick={() => handlePopupResponse("yes")}
                      className='inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto'
                    >
                      Yes
                    </button>
                    <button
                      type='button'
                      onClick={() => handlePopupResponse("no")}
                      className='mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto'
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {endcallPopup && (
        <div className='popup'>
          <div
            className={`fixed inset-0 z-[10000] transition-opacity ${
              endcallPopup
                ? "ease-out duration-300 opacity-100"
                : "ease-in duration-200 opacity-0"
            }`}
            aria-labelledby='modal-title'
            role='dialog'
            aria-modal='true'
          >
            <div className='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity'></div>

            <div className='fixed inset-0 z-10 w-screen overflow-y-auto'>
              <div className='flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0'>
                <div
                  className={`relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg ${
                    endcallPopup
                      ? "ease-out duration-300 opacity-100 translate-y-0 sm:scale-100"
                      : "ease-in duration-200 opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  }`}
                >
                  <div className='bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4'>
                    <div className='sm:flex items-center'>
                      <div className='mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10'>
                        <svg
                          className='text-red-600 w-6 h-6'
                          aria-hidden='true'
                          xmlns='http://www.w3.org/2000/svg'
                          fill='none'
                          viewBox='0 0 20 20'
                        >
                          <path
                            stroke='currentColor'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth='2'
                            d='M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z'
                          />
                        </svg>
                      </div>
                      <div className='mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left'>
                        <h3
                          className='text-base font-semibold leading-6 text-gray-900'
                          id='modal-title'
                        >
                          Are you sure you want to exit interview?
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div className='bg-white px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6'>
                    <button
                      type='button'
                      onClick={() => endcallPopupResponse("yes")}
                      className='inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto'
                    >
                      Yes
                    </button>
                    <button
                      type='button'
                      onClick={() => endcallPopupResponse("no")}
                      className='mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto'
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {isOpen && validationMessage && (
        <div className='popup'>
          <div className='fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center'>
            <div className='bg-white rounded-lg shadow-lg p-6 max-w-sm w-full'>
              <h2 className='text-lg font-semibold text-gray-900 mb-2'>Message</h2>
              <p className='text-gray-700 mb-4'>{validationMessage}</p>
              <button
                onClick={() => {
                  setValidationMessage("");
                  setIsOpen(false);
                }}
                className='bg-green-500/80 hover:bg-green-600/90 px-6 py-2 rounded-full text-white font-semibold transition-colors mx-auto block'
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Display current transcript */}
      {displayTranscript && (
        <div className='absolute top-4 left-4 right-20 bg-black/50 text-white p-3 rounded-lg z-20'>
          <p className='text-sm'>{displayTranscript}</p>
        </div>
      )}

      <div className='col-span-3 m-0 p-0'>
        <div className='w-full'>
          <div className='relative'>
            {/* Timer Display - Top Right */}
            {startRecord && isTimerLoaded && (
              <div className={`absolute top-4 right-4 p-2 rounded-lg z-10 font-bold ${
                timeRemaining <= 60 ? 'bg-red-600 text-white' : 'bg-blue text-white'
              }`}>
                {formatTime(timeRemaining)}
              </div>
            )}

            <div className='inset-0 justify-center items-center'>
             
              <div
                className={`absolute bottom-0 left-1/2 transform -translate-x-1/2 m-3 z-10 flex gap-3 ${
                  isOpen ? "pointer-events-none opacity-50" : ""
                }`}
              >
                {/* Microphone Button */}
                <button
                    type="button"
                    onClick={listening ? audioOff : listenContinuously}
                    disabled={isMicDisabled}
                    className={`
                        bg-gray-100/50
                        rounded-full w-[50px] h-[50px] p-2
                        flex items-center justify-center
                        transition-colors
                        ${
                        isMicDisabled
                            ? "opacity-50 cursor-not-allowed"
                            : "hover:bg-gray-200/60"
                        }
                    `}
                    >
                    {listening ? (
                        <span className="relative flex">
                        <span className="animate-ping absolute inline-flex w-full h-full p-2 rounded-full bg-blue-500 opacity-75"></span>
                        <img
                            src={microphone}
                            className="w-[25px] h-[25px]"
                            alt="Muted Microphone"
                        />
                        </span>
                    ) : (
                        <img
                        src={microphoneSlash}
                        className="w-[25px] h-[25px]"
                        alt="Active Microphone"
                        />
                    )}
                </button>

                {/* Submit & Next Button - Show only if NOT last question */}
                {startRecord && !isLastQuestion && (
                    <button
                        type='button'
                        onClick={handleNextQuestion}
                        disabled={isFetchingQuestion || isMicDisabled}
                        className={`bg-green-500/80 hover:bg-green-600/90 p-2
                            rounded-full min-w-[80px] h-[50px]
                            flex items-center justify-center
                            text-white font-semibold text-sm px-3
                            transition-colors
                            ${
                            isFetchingQuestion || isMicDisabled
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                        >
                        Submit & Next
                    </button>
                )}

                {/* Submit & Finish Button - Show only if last question */}
                {startRecord && isLastQuestion && (
                    <button
                        type="button"
                        onClick={handleFinishInterview}
                        disabled={isFetchingQuestion || isMicDisabled}
                        className={`
                        bg-green-500/80 hover:bg-green-600/90 p-2
                        rounded-full min-w-[100px] h-[50px]
                        flex items-center justify-center
                        text-white font-semibold text-sm px-4
                        transition-colors
                        ${
                            isFetchingQuestion || isMicDisabled
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }
                        `}
                    >
                        Submit & Finish
                    </button>
                )}

                {/* Skip Button - Show only if NOT last question */}
                {startRecord && !isLastQuestion && (
                    <button
                        type="button"
                        onClick={handleSkipQuestion}
                        disabled={isFetchingQuestion || isMicDisabled}
                        className={`
                        bg-orange-500/80 hover:bg-orange-600/90
                        rounded-full min-w-[80px] h-[50px]
                        flex items-center justify-center
                        text-white font-semibold text-sm px-4
                        transition-colors
                        ${
                            isFetchingQuestion || isMicDisabled
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }
                        `}
                    >
                        Skip
                    </button>
                )}

                {/* End Call Button */}
                {startRecord && (
                    <button
                        type="button"
                        onClick={handlePopupCall}
                        disabled={stopDisable}
                        className={`
                        bg-gray-100/50
                        rounded-full w-[50px] h-[50px]
                        flex items-center justify-center
                        transition-colors
                        ${
                            stopDisable
                            ? "opacity-50 cursor-not-allowed"
                            : "hover:bg-gray-200/60"
                        }
                        `}
                    >
                        <img
                        src={endCall}
                        className="w-[25px] h-[25px]"
                        alt="Stop Screen Record"
                        />
                    </button>
                )}
              </div>
              
              <Webcam
                ref={webcamRef}
                className='rounded-2xl video'
                audio={false}
                mirrored={true}
                videoConstraints={videoConstraints}
                onUserMediaError={() => {
                  console.log("error");
                }}
              />
            </div>
            
            <div className='absolute bottom-0 right-0 p-2.5'>
              <div className='lg:w-[170px] lg:h-[120px] w-[50px] h-[50px] rounded-md border-2 border-[#6baafa] text-white flex items-center justify-center rounded-full bg-[#4d514f] flex-shrink-0 lg:text-3xl text-1xl'>
                <span className='relative flex items-center justify-center'>
                  {aiAudioPlay && (
                    <span className='animate-ping absolute inline-flex w-full h-full text-center rounded-full border-2 border-zinc-500 opacity-75'></span>
                  )}

                  <div className='w-[50px] h-[50px] bg-[#6279ca] content-center rounded-full flex items-center justify-center z-[999]'>
                    RI
                  </div>

                  {aiAudioPlay && (
                    <span className='animate-ping absolute inline-flex w-[35px] h-[35px] text-center rounded-full bg-gray-500'></span>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Video;
